import { dynamicContentFragment } from '../../graphql/fragments/dynamicContentFragment';
import { weblinkFragment } from '../../graphql/fragments/weblinkFragment';
import { graphql } from '../../graphql/graphql';

const helmetFragment = graphql(`
  fragment Helmet on StreetPage_Page {
    helmet {
      canonical
      title
      description
      siteName
    }
  }
`);

const breadCrumbsFragment = graphql(`
  fragment BreadCrumbs on StreetPage_Page {
    breadCrumbs {
      title
      url
    }
  }
`);

const titleFragment = graphql(`
  fragment Title on StreetPage_Page {
    title {
      parts
    }
  }
`);

const propertyCollectionsFragment = graphql(`
  fragment PropertyCollections on StreetPage_Page {
    propertyCollections {
      subtitle
      title
      collectionType
      properties {
        address
        path
        imageV2 {
          alt
          caption
          jpgUri: uri(width: 224, height: 126, imageMode: Crop, progressive: true)
          webpUri: uri(width: 224, height: 126, format: WEBP, imageMode: Crop, progressive: true)
        }
        badge {
          text
          variant
        }
        priceV2 {
          display
          sourceLevel
        }
        features {
          iconNameV2
          title
          hoverTitle
          valueWithUnit
        }
        soldDate
        clickThroughTracking {
          pathname
          page
          element
          sourceType
        }
      }
      tracking {
        showMoreProperties {
          schema
          data {
            event_name
            in_page_source
            user_action
          }
        }
      }
    }
  }
`);

const propertiesFragment = graphql(`
  fragment Properties on StreetPage_Page {
    properties {
      title
      subtitle
      items {
        visible {
          link {
            url
            title
          }
        }
        hidden {
          link {
            url
            title
          }
        }
      }
      showMoreButton {
        title
      }
    }
  }
`);

const mediaPartnerBannerFragment = graphql(
  `
    fragment MediaPartnerBanner on StreetPage_Page {
      mediaPartnerBanner @skip(if: $toggleMediaPartnerBannerTemporaryCampaign) {
        text
        link {
          ...WebLink
        }
      }
    }
  `,
  [weblinkFragment],
);

const mediaPartnerBannerTemporaryCampaignFragment = graphql(
  `
    fragment MediaPartnerBannerTemporaryCampaign on StreetPage_Page {
      mediaPartnerBannerTemporaryCampaign @include(if: $toggleMediaPartnerBannerTemporaryCampaign) {
        text
        link {
          ...WebLink
        }
        termsAndConditions {
          ...DynamicContent
        }
        termsAndConditionsShort
      }
    }
  `,
  [weblinkFragment, dynamicContentFragment],
);

export const streetPageQuery = graphql(
  `
    query StreetPageBySlug(
      $slug: StreetPageSlug!
      $toggleMediaPartnerBannerTemporaryCampaign: Boolean = false
    ) {
      streetPageBySlug(slug: $slug) {
        id
        vgDisclaimerHtml
        ...Helmet
        ...BreadCrumbs
        ...Title
        ...PropertyCollections
        ...Properties
        ...MediaPartnerBanner
        ...MediaPartnerBannerTemporaryCampaign
      }
    }
  `,
  [
    helmetFragment,
    breadCrumbsFragment,
    titleFragment,
    propertyCollectionsFragment,
    propertiesFragment,
    mediaPartnerBannerFragment,
    mediaPartnerBannerTemporaryCampaignFragment,
  ],
);
